import { Box, Flex, IconButton, Input } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { HiMinus, HiPlus, HiTrash } from 'react-icons/hi2';

export default function ProductItemQty({ showControlQty = true, showInputQty = true, max = 10, min = 1, canDelete = true, size = 'sm', defaultValue = 0, isDisabled = false, data = {}, onChangeQty = (qty) => {}, onDeleteItem = () => {} }) {
    const [value, setValue] = useState(defaultValue);

    const decrement = () => {
        let qty = parseInt(value);

        qty = qty - 1;
        if (qty < 0) qty = 0;

        setValue(qty);
        handleChangeQty(qty);
    };

    const increment = () => {
        let qty = parseInt(value);

        if (qty >= max) {
            return;
        }

        qty = qty + 1;

        setValue(qty);
        handleChangeQty(qty);
    };

    const handleChangeQty = (qty) => {
        if (typeof onChangeQty === 'function') {
            let tempQty = qty;

            if (qty >= max) {
                tempQty = max;
            }

            onChangeQty(tempQty);
        }
    };

    useEffect(() => {
        if (min > 0 && defaultValue < min) {
            setValue(min);
            handleChangeQty(min);
        } else {
            if (typeof defaultValue === 'number') {
                setValue(defaultValue);
                handleChangeQty(defaultValue);
            }
        }
    }, [min, defaultValue]);

    const isDisableDecreement = isDisabled || value <= min;
    const isDisableIncreement = isDisabled || value >= max;

    return (
        <Flex w='full' alignItems='center' justifyContent='space-between'>
            <Box w='full'>
                <Flex w='full' alignItems='center' justifyContent='end' gap={2}>
                    {showControlQty && <IconButton isDisabled={isDisableDecreement} icon={<HiMinus />} size={size} variant='outline' colorScheme='red' onClick={decrement} _disabled={{ opacity: 0.1 }} />}

                    {showInputQty && (
                        <Input
                            isDisabled={true}
                            type='number'
                            w='75px'
                            size={size}
                            rounded='md'
                            variant='filled'
                            colorScheme='secondary'
                            maxLength={3}
                            max={max}
                            value={value}
                            defaultValue={defaultValue}
                            textAlign={'center'}
                            _disabled={{ color: 'black' }}
                            onChange={(event) => {
                                const qty = parseFloat(event.target.value || '0');

                                if (qty < 0) {
                                    handleChangeQty(0);
                                } else {
                                    handleChangeQty(qty);
                                }
                            }}
                            onSubmit={(event) => {
                                const qty = parseFloat(event.target.value);
                                handleChangeQty(qty);
                            }}
                        />
                    )}

                    {showControlQty && <IconButton isDisabled={isDisableIncreement} icon={<HiPlus />} size={size} variant='solid' colorScheme='primary' value='1' defaultValue='1' textAlign='center' onClick={increment} />}
                </Flex>
            </Box>
            {canDelete && (
                <Box ml={2}>
                    <IconButton icon={<HiTrash />} size='sm' variant='outline' colorScheme='red' onClick={() => onDeleteItem()} />
                </Box>
            )}
        </Flex>
    );
}
